import type { FunnelStatsResponseDto } from '@lunary/api-client'
import { HBars } from '../../shared/ui/charts/hbars'
import { percent } from './series'
import styles from './overview.module.css'

export function FunnelSection({ data }: { data: FunnelStatsResponseDto }) {
  const steps = [
    { key: 'created', label: 'Пришли (с гостями)', value: data.created },
    { key: 'identified', label: 'Вошли (не гости)', value: data.identified },
    { key: 'daily', label: 'Получили карту дня', value: data.daily_reading },
    { key: 'order', label: 'Заказали разбор', value: data.arcana_order },
    { key: 'ready', label: 'Получили разбор', value: data.arcana_ready },
  ]
  return (
    <section className={styles.section} aria-labelledby="ov-funnel">
      <h2 id="ov-funnel">Воронка</h2>
      <div className="card-panel">
        <p className={styles.caption}>Пользователи, пришедшие за период, и сколько из них дошли до шага</p>
        <HBars
          label="Воронка"
          color="var(--accent)"
          items={steps.map((s, i) => ({
            ...s,
            note: i === 0 ? undefined : `${percent(s.value, steps[i - 1]?.value ?? 0)} от прошлого шага`,
          }))}
        />
      </div>
    </section>
  )
}
